<template>
    <div class="captail_wrap registrationSteps position-relative fullLoader p-0 w-100">
		<loader v-if="pageLoader"></loader> 
        <div class="middle_section m-0">
            <div class="top_searchbars">
                <div class="row">
                    <div class="col-12">
					   <div class="cap_logo_steps centerLogo p-3 d-flex justify-content-between align-items-center">
							<a href="#"><img src="../../../../static/website/images/logo.png" alt="Captail wallet"></a>
							<div class="rightBack d-flex align-items-center">
								<a href="#" class="backToDash" @click.prevent="logout()">Logout</a>
						    </div> 
						</div>
                    </div>
                </div>
            </div>
			<div class="  d-flex align-items-center justify-content-center">
				<app-twofa :call_from="'twoFaAfterRegisteration'"  class="withdrawalAllow w-100 "></app-twofa>
			</div>
        </div>
    </div>
</template>
<script>
	import TwoFa from './security'
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	export default {
		name: 'step-four',
		data() {
			return {
				submitted : false,
				pageLoader : false,
			}
		},
		components: {
			appTwofa : TwoFa
		},
		methods: {
			...mapActions({
				_runLogout: types.RUN_LOGOUT
			}),
			logout(){
				let input_json={
					'globalParams' :{},
					'localParams' :{ "parameter" : this }
				}
				this._runLogout(input_json)
			},
		},
		created(){}
	}
</script>



// WEBPACK FOOTER //
// src/components/website/security/twoFaAfterLoginRegister.vue